import { createFileRoute } from '@tanstack/react-router'
import ManageExtensions from 'pages/manageExtensions/ManageExtensions'

export const Route = createFileRoute('/extensions/$orgID')({
  component: ManageExtensions,
  staticData: {
    title: 'Extensions',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
      showNavbar: false,
    },
  },
})
